export const CUSTOMER_TRANSACTIONS_APIS = {
  get_booked_listing_types: "payments/booked/listings/type/list",
};
